<template>
  <b-row>
    <b-col>
      <div>
        <div>
          <b-row class="justify-content-between mb-3">
            <b-col class="d-flex align-items-center">
              <h2 class="mb-0">
                <b-badge variant="secondary">Invités</b-badge>
              </h2>
            </b-col>
            <b-col cols="3" sm="6" md="3">
              <label>Rechercher</label>
              <b-form-input v-model="search" placeholder="Tapez pour rechercher" @input="filter" />
            </b-col>
          </b-row>
        </div>

        <b-table bordered class="agv-table" :fields="fields" :items="tableData" show-empty>
          <template v-slot:cell(fullname)="row">
            <div class="text-left" style="min-width: 180px;">
              {{ row.item.fullname }}
            </div>
          </template>
          <template v-slot:cell(email)="row">
            <div class="text-left" style="min-width: 160px;">
              {{ row.item.email }}
            </div>
          </template>
          <template v-slot:cell(access_status)="row">
            <div class="text-center">
              {{ showAccessStatus(row.item.access_status) }}
            </div>
          </template>
          <template v-slot:cell(_actions)="row">
            <div class="d-flex justify-content-center align-items-center">
              <b-button
                class="tablebutton btn-edit"
                variant="white"
                @click="updateGuest(row.item, 1)"
              >
                <font-awesome-icon icon="user-check" size="lg" />
                <span class="font-15 ml-2">Permettre</span>
              </b-button>
              <span>{{ " | " }}</span>
              <b-button
                class="tablebutton btn-red"
                variant="white"
                @click="updateGuest(row.item, 2)"
              >
                <font-awesome-icon class="ml-2" icon="user-times" size="lg" />
                <span class="font-15 ml-2">Refuser</span>
              </b-button>
            </div>
          </template>
          <template #empty>
            <span>{{ "Aucune donnée n'a été trouvée..." }}</span>
          </template>
        </b-table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { meetingGuestAccessStatuses } from "@/constants/meeting-guest.js";
import MeetingGuestMW from "@/middlewares/MeetingGuest";
export default {
  components: {
    appVotingsMandateName: () =>
      import("@/components/b-table-components/votingTable/VotingsMandateName"),
  },
  props: {
    meetingGuests: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      meetingGuestAccessStatuses,
      fields: [
        {
          key: "fullname",
          sortable: true,
          label: "Nom",
        },
        {
          key: "email",
          sortable: false,
          label: this.$t("meetings.email"),
        },
        {
          key: "access_status",
          label: "Statut d'accès",
        },
        {
          key: "_actions",
          label: "Actions",
        },
      ],
      search: "",
    };
  },
  created() {
    this.tableData = this.sorted(this.meetingGuests);
  },
  methods: {
    sorted(meetingGuests) {
      return this.$_.sortBy(meetingGuests, meetingGuest => {
        return meetingGuest.fullname;
      });
    },
    filter(e) {
      let result = this.$_.filter(this.meetingGuests, meetingGuest => {
        return meetingGuest.fullname.toLowerCase().includes(e);
      });
      this.tableData = this.sorted(result);
    },
    showAccessStatus(dbStatus) {
      if (this.meetingGuestAccessStatuses.allow == dbStatus) {
        return "Permettre";
      } else if (this.meetingGuestAccessStatuses.deny == dbStatus) {
        return "Refuser";
      }
    },
    updateGuest(meetingGuest, accessStatus) {
      meetingGuest.access_status = accessStatus;
      MeetingGuestMW.PUT(meetingGuest);
    },
  },
};
</script>
